import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { pKeyword } from '../interfaces/pKeyword';
import { WebAddresses } from '../app.config';
import { ApiResponse } from '../interfaces/api-response';
import { openSnackBar } from '../helpers/genericFunctions';
import { MatSnackBar } from '@angular/material/snack-bar';
import { globalUser } from '../helpers/globalFields';
import { masterpKeyword } from '../interfaces/masterData';


@Injectable({
  providedIn: 'root'
})
export class PKeywordService {

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) { }

  /**
   * allows easy switching between production and development webserver addresses for api
   */
  private baseUrl = WebAddresses.tCCTicketServer;

  
  getDefaultList(): Observable<masterpKeyword[]> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/api/data/masterpkeyword/findall`, { 
      headers: globalUser.getHeaders() 
    }).pipe(
      tap(response => {
        if (response.status != "success") {
          openSnackBar(response.message, 10000, this.snackBar);
        }
      }),
      map(response => response.data ?? []),
      catchError(error => {
        console.error("Error fetching default pKeywords:", error);
        return throwError(() => new Error("Failed to fetch default pKeywords"));
      })
    );
  }

  getByTicketID(pticket_id:Number): Observable<pKeyword[]> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/api/pkeyword/findbyticketid/${pticket_id}`, { 
      headers: globalUser.getHeaders() 
    }).pipe(
      tap(response => {
        if (response.status != "success") {
          openSnackBar(response.message, 10000, this.snackBar);
        }
      }),
      map(response => response.data ?? []),
      catchError(error => {
        console.error("Error fetching pKeyword by pTicket ID:", error);
        return throwError(() => new Error("Failed to fetch pKeyword by pTicket ID."));
      })
    );
  }

  deleteAllByPTicketID(pticket_id:Number): Observable<pKeyword[]> {
    return this.http.delete<any>(`${this.baseUrl}/api/pkeyword/deleteallbyticketid/${pticket_id}`, { 
      headers: globalUser.getHeaders() 
    }).pipe(
      tap(response => {
        if (response.status != "success") {
          openSnackBar(response.message, 10000, this.snackBar);
        }
      }),
      map(response => response.data ?? []),
      catchError(error => {
        console.error("Error deleting pKeyword by pTicket ID:", error);
        return throwError(() => new Error("Failed to delete pKeyword by pTicket ID."));
      })
    );
  }

  deleteByID(id: Number): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/api/pkeyword/delete/${id}`, { 
      headers: globalUser.getHeaders() 
    }).pipe(
      tap(response => {
        if (response.status != "success") {
          openSnackBar(response.message, 10000, this.snackBar);
        }
      }),
      map(response => response.data ?? []),
      catchError(error => {
        console.error("Error deleting pKeyword:", error);
        return throwError(() => new Error("Failed to delete pKeyword."));
      })
    );
  }

  create(keyword:any): Observable<any> {
    return this.http.post<ApiResponse>(`${this.baseUrl}/api/pkeyword/create`, keyword, { 
      headers: globalUser.getHeaders() 
    }).pipe(
          tap(response => {
            if (response.status != "success") {
              openSnackBar(response.message, 10000, this.snackBar);
            }
          }),
          map(response => response.data ?? []),
          catchError(error => {
            console.error("Error creating pKeyword:", error);
            return throwError(() => new Error("Failed to create pKeyword"));
          })
        );
  }

  
}
